import { Toaster } from "react-hot-toast";
import Layout from "../shared/Layout";
import { useCallback, useEffect, useState } from "react";
import { API_URL, baseurl } from "../../_config";
import axios from "axios";
import { useParams } from "react-router-dom";

const BookingDetailByLoginId = () => {
    const [error, setError] = useState();
    const [bookingDataByLoginId, setbookingDataByLoginIdByLoginId] = useState([]);
    const params = useParams();
    const LoginId = params?.id;

    const fetchbookingDataByLoginId = useCallback(async () => {
        try {
            const response = await axios.get(`${baseurl}${API_URL.getBookingDetailByLoginId}/${LoginId}`);
            if (response.status === 200) {
                setbookingDataByLoginIdByLoginId(response?.data?.data)
            }
        } catch (error) {
            setError("Error fetching menu data:", error);
        }
    }, [LoginId]);

    useEffect(() => {
        fetchbookingDataByLoginId();
    }, [fetchbookingDataByLoginId]);


    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading d-flex" style={{ gap: "20px" }}>
                        <span onClick={() => window.history.back()} className="back-link" title="back">
                            <i className="fa fa-arrow-left"></i>
                        </span>
                        <h4 className="mb-0">Booking Detail of {bookingDataByLoginId[0]?.Name}</h4>
                    </div>
                </div>
                {error ? (
                    <p>Data not avaiable</p>
                ) : (
                    <div className="row">
                        {bookingDataByLoginId && bookingDataByLoginId.length > 0 ? (
                            bookingDataByLoginId.map((booking, index) => (
                                <div className="col-md-3" key={index}>
                                    <div key={index} className="booking_warp_box  mt-4">
                                        <div className="card-body">
                                            <h5 className="card-title mb-2">Booking ID: {booking?.BookingId}</h5>
                                            <p className="card-text"><strong>Email:</strong> {booking?.EmailId}</p>
                                            <p className="card-text"><strong>Mobile:</strong> {booking?.MobileNo}</p>
                                            <p className="card-text">
                                                <strong>Slot Date:</strong> {new Date(booking?.SlotDate).toLocaleDateString()}
                                            </p>
                                            <p className="card-text"><strong>Slot:</strong> {booking?.Slot}</p>
                                            <p className="card-text"><strong>Status:</strong> {booking?.BookingStatus === 'N' ? 'Not Confirmed' : 'Confirmed'}</p>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <p className="no_data">No booking data available.</p>
                        )}
                    </div>
                )}
            </div>
        </Layout>
    )
}

export default BookingDetailByLoginId;